<style scoped lang="less">
  .chamada-error {
    color: red;
    font-size: 1.5em;
  }
</style>
<template>
    <div class="app-form frame-page basic-form-vue">
      <div class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">Consultas</span>
        </div>

        <div class="h-panel-body">

          <div class="h-row text-center">
            Processamentos: {{exibirStatusProcessamento}}

            &nbsp; <a href="#" title="recarregar" @click="getChamadas"><i class="fas fa-sync-alt"></i></a>
          </div>
          <div class="h-row">&nbsp;</div>

          <Table border :height="400" ref="table" :datas="chamadas">
            <TableItem title="" :width="50">
              <template slot-scope="{data}">
                <i title="Erro no processamento" v-if="data.statusProcessamento === 'Erro'" class="fas fa-exclamation-circle chamada-error"></i>
              </template>
            </TableItem>
            <TableItem title="Integração" :width="200" prop="integracaoNome"></TableItem>
            <TableItem title="Chamada Feita Por" prop="criadoPor" :width="140"></TableItem>
            <TableItem title="Data Criação" :width="100" align="center">
              <template slot-scope="{data}">
                {{moment(data.criadoEm).format('DD/MM/YYYY')}}
              </template>
            </TableItem>
            <TableItem title="Processado Em" :width="100" align="center">
              <template slot-scope="{data}">
                {{data.fimProcessamento === '0001-01-01T00:00:00Z' ? '-' : moment(data.fimProcessamento).fromNow()}}
              </template>
            </TableItem>
            <!--TableItem title="Duração" :width="100" align="center">
              <template slot-scope="{data}">
                {{data.duracao ? data.duracao.split('.')[0] : ''}}
              </template>
            </TableItem-->
            <TableItem title="Parâmetros Chamada" :width="140" align="center">
              <template slot-scope="{data}">
                <DropdownCustom placement="left" trigger="click" class-name="h-text-dropdown">
                  <i class="fas fa-book-reader"></i>
                  <div slot="content">
                    <ul class="h-text-dropdown-dropdown h-dropdownmenu-group">
                      <li v-for="(param, index) in data.params" :key="`param-${index}`" class="h-dropdownmenu-item">
                        <strong>{{param.field}}: </strong>{{param.valueFormatted}}
                      </li>
                    </ul>
                  </div>
                </DropdownCustom>
              </template>
            </TableItem>
            <TableItem title="Notas" :width="80" align="center">
              <template slot-scope="{data}">
                <DropdownCustom v-if="data.notas !== null && data.notas.length > 0" placement="left" trigger="click" class-name="h-text-dropdown">
                  <i class="far fa-clipboard"></i>
                  <div slot="content">
                    <ul class="h-text-dropdown-dropdown h-dropdownmenu-group">
                      <li v-for="(nota, index) in data.notas" :key="`nota-${index}`" class="h-dropdownmenu-item">
                        <strong>{{moment(nota.date).format('DD/MM/YYYY')}}</strong> - {{nota.message}}
                      </li>
                    </ul>
                  </div>
                </DropdownCustom>
              </template>
            </TableItem>
            <TableItem title="Status" :width="120" align="center">
              <template slot-scope="{data}">
                <span v-if="data.status === 'Aguardando'" class="h-tag h-tag-gray">{{data.status}}</span>
                <span v-if="data.status === 'Finalizado'" class="h-tag h-tag-blue">{{data.status}}</span>
                <span v-if="data.status === 'Processando'" class="h-tag h-tag-yellow">{{data.status}}</span>
              </template>
            </TableItem>
          </Table>
        </div>
      </div>
    </div>
</template>
<script>
import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');
export default {
  data() {
    return {
      chamadas: []
    };
  },
  computed: {
    exibirStatusProcessamento() {
      if (this.chamadas.length === 0) {
        return '';
      }
      return `${this.chamadas.filter(x => x.status === 'Finalizado').length} de ${this.chamadas.length} finalizados`;
    }
  },
  mounted: async function () {
    this.getChamadas();
  },
  created() {
    Utils.trackingF360(this, 'Listar', 'Gerenciar - Integrações');
  },
  methods: {
    getChamadas: async function () {
      this.$Loading();
      const resp = await R.Integracao.listarControleExecucao();
      this.chamadas = resp.data;
      this.$Loading.close();
    },
    moment: moment
  }
};
</script>
